import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  private userLoggedIn = new BehaviorSubject<boolean>(false);
  userLoggedIn$ = this.userLoggedIn.asObservable();

  sidebarOpen = signal<boolean>(true);
  visible = signal<boolean>(false);
  // selectedTab = signal<string>('Dashboard');

  getUserLoggedIn(): boolean {
    return localStorage.getItem('isUserLoggedIn') === 'true';
  }

  setUserLoggedIn(isLoggedIn: boolean): void {
    this.userLoggedIn.next(isLoggedIn);
    localStorage.setItem('isUserLoggedIn', isLoggedIn.toString());
  }

  toggleSidebar() {
    this.sidebarOpen.update(value => !value);
  }

  openSidebar() {
    this.sidebarOpen.set(true);
  }

  closeSidebar() {
    this.sidebarOpen.set(false);
  }

  openDialog(): void {
    this.visible.set(true);
  }

  closeDialog(): void {
    this.visible.set(false);
  }

  // setSelectedtab(selectedTab: string) {
  //   this.selectedTab.set(selectedTab);
  // }

//   getSelectedtab() {
//     return this.selectedTab()

// }

}